/**
 * Session Validation Service
 *
 * Slimmed in Phase 121 W2/BUG-121-C1 (2026-07-09). This service now owns only the
 * session-expiry/access-denied UX handlers, which are its sole live consumers
 * (apiClient response interceptor and activityMonitor).
 *
 * Removed (dead code that also violated the BR-3 two-layer gateway):
 * - sessionHealthCheck / validateBeforeOperation / refreshSessionIfNeeded /
 *   getSessionSummary — depended on getProfile(), which called auth-service
 *   directly at a hardcoded URL; unmounted since Phase 76 and browser-unworkable
 *   under cookie auth (HTTPBearer endpoints).
 * - hasAdminRole / validateUserPermissions (BUG-121-AUTH6) — read `user.is_admin`,
 *   a field removed backend-wide, so they were permanently false/deny-all.
 *   Authorization is enforced server-side by the BFF's gate(); the client must not
 *   duplicate it.
 * If session-health polling is ever wanted, build it as BFF proxy routes per
 * Phase 96's change-password pattern.
 */

import {
  showUserManagementError,
  USER_MANAGEMENT_ERRORS
} from '@utils/userManagementErrors'

class SessionValidationService {

  // Phase 76 M5 Task 5.2: validateAdminSession() removed.
  // Pre-flight validation was redundant with BFF gate() enforcement.
  // See Decision D14 in phase_plan.md.

  /**
   * Handle expired session scenario
   * Redirects to login while preserving current route
   */
  handleSessionExpired(): void {
    // Store current route for redirect after login
    const currentPath = window.location.pathname
    localStorage.setItem('redirect_after_login', currentPath)

    // Redirect to login
    window.location.href = '/login'
  }

  /**
   * Handle access denied scenario
   * Shows appropriate message without redirect
   */
  handleAccessDenied(): void {
    showUserManagementError(
      new Error(USER_MANAGEMENT_ERRORS.ADMIN_PRIVILEGES_REQUIRED),
      'access_control'
    )
  }

  // Phase 63: Session timeout functions removed
  // Session timeout is now handled by ActivityMonitor heartbeat mechanism
  // See: frontend/react-app/src/services/activityMonitor.ts
}

// Export singleton instance
export const sessionValidationService = new SessionValidationService()
export default sessionValidationService
